if (!customElements.get('share-button')) {
    customElements.define('share-button', class ShareButton extends HTMLElement {
      constructor() {
        super();
  
  
        this.elements = {
          fallback: this.querySelector('.details'),
          shareButton: this.querySelector('button'),
          urlInput: this.querySelector('input'),
          label: this.querySelector('.share-button__label')
        }
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
  
          if (navigator.share) {
              this.elements.label.classList.add('hidden');
          this.elements.fallback.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
        }
      }
  
  
    
  
    });
  }